import React, { useRef, useState, useEffect } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import { SelectChangeEvent } from '@mui/material/Select'
import TagPriorityRisks from './TagPriorityRisks'
import { useTranslation } from 'react-i18next'
import Select, { SingleValue } from 'react-select'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import '../../i18n'

interface SelectPriorityProps {
  value: number
  onChange: (event: SelectChangeEvent<number>, child?: React.ReactNode) => void
  portalTargetSelector?: string
  /** Hide floating label when a parent FormField already shows one. */
  hideLabel?: boolean
}

const SelectPriorityRisks: React.FC<SelectPriorityProps> = ({
  value,
  onChange,
  portalTargetSelector = '.page-content',
  hideLabel = true,
}) => {
  const menu = useExclusiveMenu()
  const { t } = useTranslation()
  const containerRef = useRef<HTMLDivElement>(null)


  const selectOptions = [1, 2, 3].map((priority) => ({
    value: priority,
    label: t(`prioritRisk.${priority}`, { defaultValue: String(priority) }),
  }))

  const selectedOption =
    selectOptions.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: number; label: string }>
  ) => {
    const event = {
      target: { value: selected ? selected.value : 0 },
    } as SelectChangeEvent<number>
    onChange(event)
  }

  const formatOptionLabel = (option: { value: number; label: string }) => (
    <TagPriorityRisks priority={option.value} />
  )

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('Priority')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select<{ value: number; label: string }, false>
          value={selectedOption}
          onChange={handleSelectChange}
          options={selectOptions}
          formatOptionLabel={formatOptionLabel}
          placeholder={t('Priority')}
          styles={incyiaSelectStyles}
          {...menu}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectPriorityRisks
